/* eslint-disable @typescript-eslint/no-require-imports */
import type { ImgHTMLAttributes } from 'react';

const getGoalCategoryImageUrl = (slug: string) => {
  try {
    return require('@resources/img/account/rewards/goals/categories/' + slug + '.svg?url') as string;
  } catch {
    return undefined;
  }
}

interface GoalCategoryImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  slug: string
}

export default function GoalCategoryImage(props: GoalCategoryImageProps) {
  const {
    slug,
    alt = '',
    style,
    ...imageProps
  } = props;
  const imageUrl = getGoalCategoryImageUrl(slug);

  if (imageUrl === undefined) {
    return null;
  }

  return <img
    {...imageProps}
    src={imageUrl}
    alt={alt}
    style={{
      width: '36px',
      ...style,
    }}
  />
}
